import { createSlice } from "@reduxjs/toolkit";

import { clearSelectedCompanyWithCollaborativesDispatch } from "../dispatch/company/clear-selected-companywith-collaboratives";
import { setCompanyWithCollaborativesInPageByDtoDispatch } from "../dispatch/company/set-company-with-collaboratives-in-page-by-dto";
import { setCompanyWithCollaborativesPageDispatch } from "../dispatch/company/set-company-with-collaboratives-page";
import { setCompanyWithCollaborativesPageAllDispatch } from "../dispatch/company/set-company-with-collaboratives-page-all";
import { setSelectedCompanyWithCollaborativesDispatch } from "../dispatch/company/set-selected-company-with-collaboratives";
import { RootState } from "../store";
import { CompanyState } from "../type/company-state";

const initialPage = {
  contents: [],
  first: true,
  last: true,
  page: 0,
  totalPages: 1,
  totalElements: 0,
};

const initialState: CompanyState = {
  selectedCompany: undefined,
  companyPage: initialPage,
  selectedCompanyWithCollaboratives: undefined,
  companyWithCollaborativesPage: initialPage,
  companyWithCollaborativesPageAll: initialPage,
  status: "idle",
};

export const companySlice = createSlice({
  name: "companySlice",
  initialState,
  reducers: {
    setCompanyWithCollaborativesInPageByDtoAction:
      setCompanyWithCollaborativesInPageByDtoDispatch,
    clearSelectedCompanyWithCollaborativesAction:
      clearSelectedCompanyWithCollaborativesDispatch,
    setCompanyWithCollaborativesPageAction:
      setCompanyWithCollaborativesPageDispatch,
    setSelectedCompanyWithCollaborativesAction:
      setSelectedCompanyWithCollaborativesDispatch,
    setCompanyWithCollaborativesPageAllAction:
      setCompanyWithCollaborativesPageAllDispatch,
  },
});

export const {
  setCompanyWithCollaborativesInPageByDtoAction,
  clearSelectedCompanyWithCollaborativesAction,
  setCompanyWithCollaborativesPageAction,
  setSelectedCompanyWithCollaborativesAction,
  setCompanyWithCollaborativesPageAllAction,
} = companySlice.actions;

export const companyState = (state: RootState) => state.company;

export default companySlice.reducer;
